import Vue from 'vue'
import Vuex from 'vuex'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import router from './routes/index.js'
import VueRouter from 'vue-router';
import Dialog from 'bootstrap-vue-dialog/dist/bootstrap-vue-dialog'
import Notifications from 'vue-notification'
// Import Bootstrap an BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.config.productionTip = false
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(Notifications)
Vue.use(Vuex)
Vue.use(Dialog, {
  notify: {
    position: 'bottom-right',
  },
})

const store = new Vuex.Store({
  state: {
      updateCount: 0,
      uid: null,
      name: null,
      calendar: null,
      isUpdate: true,
      lastUpdated: null,
      lastData: null,
      notifyIds: [],
      data: {
        friends: [],
        notification: [],
        notify: [],
        events: []
      }
  },
  getters: {
    notify: state => state.data.notify,
  },
  mutations: {
  },
  actions: {
      async getLastData() {
          return fetch('https://beta.ravadsoftware.com/calendar/api/updateTime.php')
              .then((response) => {return response.json()})
              .then((data) => {data.time > store.state.lastUpdated ? store.dispatch('updateData') : clearTimeout(store.timeout); store.timeout = setTimeout(function() {store.dispatch('getLastData')}, 5000) })
              .catch(error => {
                router.push('/login')
                Vue.notify({ group: 'notify', type: 'error', title: 'Error', text: error, duration: 3000 })
                return
            })
      },
      async updateData() {
            return fetch('https://beta.ravadsoftware.com/calendar/api/updateData.php' + (store.state.calendar ? "?id=" + store.state.calendar.id : ''))
              .then((response) => {return response.json()})
              .then((data) => {
                if (data.code === "401") {
                  router.push('/login')
                  return
                }
                store.state.lastData = JSON.parse(JSON.stringify(store.state.data))
                store.state.data = JSON.parse(JSON.stringify(data))
                store.state.lastUpdated = data.time
                store.state.uid = data.uid
                store.state.name = data.name
                clearTimeout(store.timeout)
                store.timeout = setTimeout(function() {store.dispatch('getLastData')}, 5000)
              })
              .catch(error => {
                router.push('/login')
                Vue.notify({ group: 'notify', type: 'error', title: 'Error', text: error, duration: 3000 })
                return
              })
      }
  }
})

Vue.use(VueRouter)
new Vue({
  store,
  el: '#app',
  router: router,
  vuetify: vuetify,
  created: () => {
    store.dispatch('updateData')
  },
  render: h => h(App),
})
